import React from "react";
import { connect } from "react-redux";

import MembershipCrawlContainer from "../../organisms/hotel/membershipCrawlContainer";
import { HeaderContainer } from "../../organisms/common/crawlHeaderContainer";


class MembershipCrawlTemplate extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer
          Label categoryLabel1={"ログイン"}
          categoryLabel2={"CRAWL"}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
          isLoginScreen={true}
        />
        <MembershipCrawlContainer />
      </div>
    );
  }
}

export default MembershipCrawlTemplate;